module.exports = __webpack_public_path__ + "img/the-whisky-official-flyer.f10501a8.jpeg";